export const colorPickerTheme = {
  previewSquare: {
    borderColor: 'palette.tertiary.90',
    borderRadius: '6px',
    borderWidth: '2px',
  },
  text: 'palette.neutral.80',
};
